import { Assignment } from "./Assignment";

export class AssignmentSingle extends Assignment {
    public get Name(): string {
        if (this.Items.length < 1) {
            return "";
        }
        return this.Items[0].Name;
    }
    public set Name(v: string) {
        if (this.Items.length < 1) {
            return;
        }
        this.Items[0].Name = v;
    }

    public get ResultId(): string {
        if (this.Items.length < 1) {
            return "";
        }
        return this.Items[0].ResultId;
    }
    public set ResultId(v: string) {
        if (this.Items.length < 1) {
            return;
        }
        this.Items[0].ResultId = v;
    }

}


// WEBPACK FOOTER //
// ./src/app/shared/models/AssignmentSingle.ts